module.exports = __webpack_public_path__ + "static/onwueyi-ae6e48f6ce6505234e8575bec98daa29.png";